var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVk = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.787 15.985h1.194s.36-.04.544-.23c.17-.176.164-.506.164-.506s-.02-1.566.723-1.796c.733-.225 1.677 1.496 2.677 2.162.754.5 1.328.37 1.328.37h2.672s1.395-.1.733-1.161c-.056-.085-.385-.786-1.985-2.217-1.676-1.5-1.45-1.26.564-3.852 1.231-1.581 1.718-2.547 1.57-2.962-.149-.39-1.046-.325-1.046-.325h-3.016s-.22-.02-.384.075c-.164.09-.267.335-.267.335s-.477 1.246-1.113 2.286c-1.338 2.192-1.871 2.312-2.092 2.172-.507-.315-.38-1.276-.38-1.956 0-2.127.334-3.013-.65-3.243-.329-.075-.57-.125-1.405-.135-1.072-.01-1.98.005-2.498.245-.338.16-.605.526-.446.546.2.025.651.115.892.43.308.405.298 1.31.298 1.31s.174 2.508-.416 2.818c-.405.215-.964-.225-2.153-2.212-.616-1.02-1.077-2.171-1.077-2.171s-.087-.21-.246-.325c-.195-.135-.462-.18-.462-.18L.65 5.468s-.426.01-.585.19c-.138.16-.01.49-.01.49s2.236 5.094 4.769 7.64c2.323 2.332 4.964 2.197 4.964 2.197z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vk.77955693.svg";
export { ForwardRef as ReactComponent };